module.exports = __webpack_public_path__ + "img/fourthfeatureicon.e36d87ba.webp";